<template>
<v-server-table ref="table" :url="url" :columns="columns" :options="options" class="table">
  <template slot="min0" slot-scope="props">
    <a :href="taskRowUrl(props.row.id)">{{props.row.min0}}</a>
    <div :class="'bis'+ props.row.min0">
      {{ props.row.min0}}
    </div>
  </template>
  <div class="row" slot="child_row" slot-scope="props">
    <div class="col s12 m12 l6">
      <p>{{props.row.description}}</p>
    </div>
    <div class="col s12 m6 l3 stats">
      <p><label>Project Status:</label> {{props.row.status}}</p>
      <p><label>Species Identified:</label> {{props.row.speciesCount}}</p>
    </div>
    <div class="col s12 m6 l3 stats">
      <p><label>Tasks:</label> {{props.row.tasksCount}}</p>
      <p><label>Completed:</label> {{props.row.tasksCompletedCount}}</p>
    </div>
  </div>
</v-server-table>
</template>

<script>
import Vue from 'vue'
import VueTables from 'vue-tables-2'
import {API_URL} from '@/lib/common';

Vue.use(VueTables.ServerTable);
export default {
  name: 'log-table',
  methods: {
  },
  data () {
    const pageSize = 25;
    return {
      columns: ['code', 'individual_id', 'min0', 'min1', 'min2', 'min3', 'min4', 'min5', 'min6', 'min7', 'min8', 'min9', 'AC', 'VT', 'confidence'],
      url: API_URL + 'get-task-logged-sounds',
      options: {
        childRowTogglerFirst: false,
        filterByColumn: false,
        headings: {
          code: 'Code',
          individual_id: 'Indiv_id',
          min0: '0 Min',
          min1: '1 Min',
          min2: '2 Min',
          min3: '3 Min',
          min4: '4 Min',
          min5: '5 Min',
          min6: '6 Min',
          min7: '7 Min',
          min8: '8 Min',
          min9: '9 Min'
        },
        perPage: 50,
        perPageValues: [10, 25, 50],
        pagination: { nav: 'scroll' },
        requestAdapter (data) {
          let filter = [];
          const query = data.query;
          if (query) {
            Object.keys(query).forEach(function (key) {
              filter.push({column: key, value: '*' + query[key] + '*'});
            });
          }
          return {
            sort: data.orderBy ? data.orderBy : '',
            order: data.ascending ? 'asc' : 'desc',
            limit: data.limit ? data.limit : pageSize,
            page: data.page ? data.page : 1,
            filters: filter
          }
        },
        responseAdapter (data) {
          if (data && data.total_row_count > 0) {
            return {
              data: data.results,
              count: data.total_row_count
            };
          } else {
            return { data: [], count: 0 };
          }
        },

        templates: {
          fullNm1 (h, row, index) {
            // console.log(index);
            return <div><a href={'/home/project/task?id=' + row.id + '&projectType=' + this.activeSensor }>{row.fullNm}</a></div>
          }
        }
      }
    }
  }
}
</script>
